import { IDataTh, ThCoreIndex } from "src/Pages/components";

export const THeadContratos = () => {
  const dataTh: IDataTh[] = [
    {
      title: "Ações",
      width: "40px",
      align: "left",
    },
    {
      title: "Visualizar",
      align: "center",
      width: "80px",
      minWidth: "80px",
    },
    {
      title: "Status",
      align: "left",
      width: "80px",
    },
    {
      title: "D. Assinatura",
      align: "right",
      width: "120px",
      minWidth: "120px",
      tooltip: "Data da assinatura",
    },
    {
      title: "Proposta",
      align: "left",
      width: "170px",
      minWidth: "170px",
    },
    {
      title: "Operadora/Modalidade",
      align: "left",
      minWidth: "180px",
      width: "180px",
    },
    {
      title: "Titular/Razão",
      align: "left",
      width: "200px",
      minWidth: "150px",
    },
    {
      title: "Mensalidade",
      align: "right",
      width: "110px",
      minWidth: "110px",
    },
    {
      title: "T. contrato",
      align: "left",
      width: "150px",
      minWidth: "100px",
    },
    {
      title: "Telefone(s)",
      align: "left",
      width: "130px",
      minWidth: "130px",
    },
    {
      title: "Produtor",
      align: "left",
      width: "280px",
      minWidth: "180px",
    },
    {
      title: "Administradora",
      align: "left",
      minWidth: "130px",
      width: "130px",
    },
    {
      title: "Info",
      align: "center",
      width: "50px",
    },
  ];

  return <ThCoreIndex dataTh={dataTh} />;
};
